import { render, staticRenderFns } from "./setup-overview.vue?vue&type=template&id=7aa00d9f&scoped=true"
import script from "./setup-overview.vue?vue&type=script&lang=ts"
export * from "./setup-overview.vue?vue&type=script&lang=ts"
import style0 from "./setup-overview.vue?vue&type=style&index=0&id=7aa00d9f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa00d9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa00d9f')) {
      api.createRecord('7aa00d9f', component.options)
    } else {
      api.reload('7aa00d9f', component.options)
    }
    module.hot.accept("./setup-overview.vue?vue&type=template&id=7aa00d9f&scoped=true", function () {
      api.rerender('7aa00d9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/setup-overview.vue"
export default component.exports